import { render, staticRenderFns } from "./S12Subtabs.vue?vue&type=template&id=a1a81406&scoped=true"
import script from "./S12Subtabs.vue?vue&type=script&lang=js"
export * from "./S12Subtabs.vue?vue&type=script&lang=js"
import style0 from "./S12Subtabs.vue?vue&type=style&index=0&id=a1a81406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a81406",
  null
  
)

export default component.exports